import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import Global from '../store/global-selectors';
import { updateFulfillmentPlanEntitiesOptimistically } from '../store/entities/entities.actions';
import * as Actions from './actions';

export const updateFulfillmentPlanOrderGridStatus = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.UPDATE_FULFILLMENT_PLAN_ORDER_GRID_STATUS),
    mergeMap(({ fulfillmentPlanId, orderGridStatus }) => {
      const fulfillmentPlan = Global.selectEntitiesFulfillmentPlanById(getState(), { fulfillmentPlanId });

      if (!fulfillmentPlan) {
        return EMPTY;
      }

      const updatedFulfillmentPlan = {
        ...fulfillmentPlan,
        orderGridStatus,
      };

      return of(updateFulfillmentPlanEntitiesOptimistically([fulfillmentPlanId], [updatedFulfillmentPlan]));
    }),
  );
};
